import { useState, useEffect, useCallback } from "react";
import ReusableCard from "../../utils/reusable_card";

const API_URL = `${process.env.REACT_APP_API_URL}/api/teams/get-teams`;

const TeamPage = () => {
  const [teams, setTeams] = useState([]);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);

  const [search, setSearch] = useState(""); // ← nuevo
  const [debounceSearch, setDebounceSearch] = useState(""); // ← nuevo

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const hasMore = page < pages;

  const SkeletonCard = () => (
    <div className="animate-pulse rounded-2xl border border-neutral-200 p-3 h-52 bg-neutral-100" />
  );

  const fetchTeams = useCallback(
    async (targetPage = 1, replace = false) => {
      // ← nuevo parámetro replace
      try {
        setError(null);
        setLoading(true);

        const resp = await fetch(
          `${API_URL}?page=${targetPage}&search=${debounceSearch}`, // ← añadido search
        );
        if (!resp.ok) throw new Error("Request failed");

        const json = await resp.json();

        const mapped = json.data.map((team) => ({
          id: team.id,
          name: team.team_name || team.name,
          photo: team.picture_url || team.photo_url,
          city: team.city || "Sin ciudad",
          createdAt: team.created_at,
        }));

        setTeams((prev) => (replace ? mapped : [...prev, ...mapped])); // ← reemplaza si es búsqueda nueva

        setPage(json.page);
        setPages(json.pages);
      } catch (err) {
        setError("Hubo un problema al cargar los equipos");
      } finally {
        setLoading(false);
      }
    },
    [debounceSearch], // ← dependencia del debounce
  );

  // Efecto para cargar cuando cambia la búsqueda
  useEffect(() => {
    fetchTeams(1, true); // página 1, reemplazar datos
  }, [fetchTeams]);

  // Debounce de 300ms
  useEffect(() => {
    const handler = setTimeout(() => setDebounceSearch(search), 300);
    return () => clearTimeout(handler);
  }, [search]);

  const handleLoadMore = () => {
    if (hasMore) fetchTeams(page + 1, false); // no reemplaza, concatena
  };

  return (
    <div className="p-6 max-w-6xl mx-auto">
      <header className="mb-6 flex items-center gap-3 justify-between">
        <h1 className="text-3xl font-bold tracking-tight">Equipos Wito</h1>
        {/* Input de búsqueda */}
        <input
          type="text"
          placeholder="Buscar equipo..."
          className="border rounded-lg px-3 py-2 w-52 text-sm"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </header>

      {error && (
        <div className="bg-red-100 text-red-700 px-3 py-2 mb-3 rounded-md border border-red-200">
          {error}
        </div>
      )}

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5">
        {teams.map((team) => (
          <a key={team.id} href={`/teams/${team.id}`}>
            <ReusableCard
              image={team.photo}
              name={team.name}
              city={team.city}
              date={team.createdAt}
            />
          </a>
        ))}

        {loading && (
          <>
            <SkeletonCard />
            <SkeletonCard />
            <SkeletonCard />
          </>
        )}
      </div>

      {hasMore && !loading && (
        <div className="flex justify-center mt-6">
          <button
            onClick={handleLoadMore}
            className="px-5 py-2.5 rounded-lg bg-black text-white hover:bg-neutral-800 transition text-sm"
          >
            Cargar más
          </button>
        </div>
      )}
    </div>
  );
};

export default TeamPage;
